import { FileTag } from "@remi/enums/file-tag";

// Sunrun ships the same roof drawing under three labels depending on the flow it came from, and any
// of them is what a Retrieve CAD hold is actually waiting on.
export const CAD_SATISFYING_FILE_TAGS = [
  FileTag.CAD_LAYOUT,
  FileTag.PLAN_SET,
  FileTag.DESIGN_PLAN,
] as const satisfies readonly FileTag[];
